/**
 * PageView definitions
 * id must match pathname
 *
 * Page View
 * {
 *     "id": "event_app_all_sessions_page_view",
 *     "name": "View all sessions",
 *     "type": "PageView",
 *     "path": "/sessions",
 *     "attributes": ['path'],
 *     "destinations": ["MixPanel", "Analytics", "AttendeeActivities"]
 * }
 */

import { PAGE_VIEW } from '@cvent/react-analytics';

// Common properties of PageView fact definition
const pageView = {
  type: PAGE_VIEW,
  attributes: ['path'],
  destinations: ['Mixpanel', 'Analytics', 'AttendeeActivities'],
  ver: '1.0'
};

export const myEvent = {
  ...pageView,
  path: '/events/[eventId]',
  id: 'event_app_attendee_home_page_view',
  name: 'View attendee home',
  objectIdAttribute: 'eventId',
  activityType: 'event.viewed_home'
};

export const upcomingEvents = {
  ...pageView,
  path: '/events/[eventId]/upcomingevents',
  id: 'event_app_upcoming_events_page_view',
  name: 'View upcoming events',
  objectIdAttribute: 'eventId',
  activityType: 'event.viewed_upcoming_events'
};

export const allSessions = {
  ...pageView,
  path: '/events/[eventId]/sessions',
  id: 'event_app_session_list_page_view',
  name: 'View session list',
  objectIdAttribute: 'eventId',
  activityType: 'event.viewed_session_list'
};

export const sessionDetails = {
  ...pageView,
  path: '/events/[eventId]/sessions/[id]',
  id: 'event_app_session_details_page_view',
  name: 'View session details',
  attributes: [
    ...pageView.attributes,
    'sessionId',
    'sessionName',
    'isFeatured'
    // 'isSponsored'
  ],
  objectIdAttribute: 'sessionId',
  activityType: 'session.viewed'
};

export const exhibitors = {
  ...pageView,
  path: '/events/[eventId]/exhibitors',
  id: 'event_app_exhibitors_page_view',
  name: 'View exhibitors',
  objectIdAttribute: 'eventId',
  activityType: 'event.viewed_exhibitor_list'
};

export const exhibitorDetails = {
  ...pageView,
  path: '/events/[eventId]/exhibitors/[id]',
  id: 'event_app_exhibitor_details_page_view',
  name: 'View exhibitor details',
  attributes: [
    ...pageView.attributes,
    'exhibitorId',
    'exhibitorName',
    'featuredExhibitor',
    'sponsoredExhibitor',
    'sponsorshipLevelId',
    'sponsorshipLevelName',
    'navigationSourceType',
    'navigationSourceName'
  ],
  objectIdAttribute: 'exhibitorId',
  activityType: 'exhibitor.viewed'
};

export const sponsors = {
  ...pageView,
  path: '/events/[eventId]/sponsors',
  id: 'event_app_sponsors_page_view',
  name: 'View sponsor list',
  objectIdAttribute: 'eventId',
  activityType: 'event.viewed_sponsor_list'
};

export const mySchedule = {
  ...pageView,
  path: '/events/[eventId]/schedule',
  id: 'event_app_attendee_schedule_page_view',
  name: 'View attendee schedule',
  objectIdAttribute: 'eventId',
  activityType: 'event.viewed_schedule'
};

export const game = {
  ...pageView,
  path: '/events/[eventId]/game',
  id: 'event_app_game_page_view',
  name: 'View game',
  attributes: [...pageView.attributes, 'gameId', 'gameName', 'gameStatus'],
  objectIdAttribute: 'gameId',
  activityType: 'game.viewed'
};

// TODO: update to track profile-edit page instead (HUB-93942)
// export const profile = {
//   ...pageView,
//   path: '/events/[eventId]/profile',
//   id: 'event_app_profile_page_view',
//   name: 'View profile',
//   attributes: [...pageView.attributes, 'visibility'],
//   objectIdAttribute: 'eventId',
//   activityType: 'profile.viewed',
//   destinations: ['Mixpanel', 'Analytics']
// };

export const attendees = {
  ...pageView,
  path: '/events/[eventId]/attendees',
  id: 'event_app_attendees_view',
  name: 'View attendees',
  objectIdAttribute: 'eventId',
  activityType: 'event.viewed_attendees'
};

export const admissionItemUpgrade = {
  ...pageView,
  path: '/events/[eventId]/admissionupgrade',
  id: 'open_admission_item_upgrade',
  name: 'Open Admission Item Upgrade',
  objectIdAttribute: 'eventId',
  activityType: 'event.open_admission_item_upgrade',
  destinations: ['Mixpanel', 'Analytics']
};

export const speakers = {
  ...pageView,
  path: '/events/[eventId]/speakers',
  id: 'speaker_list_viewed',
  name: 'speaker_list_viewed',
  objectIdAttribute: 'eventId',
  destinations: ['Mixpanel', 'Analytics']
};
